<template>
    <div class="container">
        <router-view />
    </div>
</template>
<script>
export default {
    name: 'industrialChain'
}
</script>
<style scoped>

</style>

